/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_9_P2Inputs */

const en_terms_section_9_p2 = /** @type {(inputs: Terms_Section_9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our total liability for any claim connected with the website will not exceed what you paid, if anything, to reach its content.`)
};

const lv_terms_section_9_p2 = /** @type {(inputs: Terms_Section_9_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mūsu kopējā atbildība par jebkuru ar tīmekļvietni saistītu prasību nepārsniegs summu, ko Jūs esat samaksājis, ja tāda ir, lai piekļūtu tās saturam.`)
};

/**
* | output |
* | --- |
* | "Our total liability for any claim connected with the website will not exceed what you paid, if anything, to reach its content." |
*
* @param {Terms_Section_9_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_9_p2 = /** @type {((inputs?: Terms_Section_9_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_9_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_9_p2(inputs)
	return en_terms_section_9_p2(inputs)
});